import type { ReactNode } from "react";

export const IdBadge = ({ value }: { value: string }) => (
  <span className="font-mono text-xs bg-surface-100 dark:bg-surface-800 border border-surface-accent-200 dark:border-surface-700 text-text-secondary dark:text-text-secondary-dark px-2 py-0.5 rounded select-all">
    {value}
  </span>
);

export const TableContainer = ({ children }: { children: ReactNode }) => (
  <div className="overflow-x-auto rounded-lg border border-surface-accent-200 dark:border-surface-700 mt-1">
    <table className="w-full text-sm border-collapse">{children}</table>
  </div>
);

export const THead = ({ children }: { children: ReactNode }) => (
  <thead className="sticky top-0 z-10 bg-surface-50 dark:bg-surface-900 border-b border-surface-accent-200 dark:border-surface-700">
    {children}
  </thead>
);

export const TH = ({ children, className }: { children?: ReactNode; className?: string }) => (
  <th
    className={`px-3 py-2 text-left text-xs font-semibold uppercase tracking-wider text-text-secondary dark:text-text-secondary-dark whitespace-nowrap ${className ?? ""}`}
  >
    {children}
  </th>
);

export const TBody = ({ children }: { children: ReactNode }) => (
  <tbody className="divide-y divide-surface-accent-100 dark:divide-surface-800">{children}</tbody>
);

export const TR = ({ children }: { children: ReactNode }) => (
  <tr className="hover:bg-surface-50 dark:hover:bg-surface-800/40 transition-colors">{children}</tr>
);

export const TD = ({ children, className }: { children?: ReactNode; className?: string }) => (
  <td className={`px-3 py-2 align-top ${className ?? ""}`}>{children}</td>
);

export const EmptyRow = ({ colSpan, label }: { colSpan: number; label: string }) => (
  <tr>
    <td
      colSpan={colSpan}
      className="px-3 py-8 text-center text-text-secondary dark:text-text-secondary-dark text-sm"
    >
      No {label} found.
    </td>
  </tr>
);
